import { render } from "./ProjectChildElementsList.vue?vue&type=template&id=db7377aa&scoped=true"
import script from "./ProjectChildElementsList.vue?vue&type=script&lang=js"
export * from "./ProjectChildElementsList.vue?vue&type=script&lang=js"

import "./ProjectChildElementsList.vue?vue&type=style&index=0&id=db7377aa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db7377aa"]])

export default __exports__